import { Button, Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { PreviousStepButton, SaveAndNextButton, SaveButton, SaveButtonsGroup } from '../../../containers/save-buttons/SaveButtonsGroup';
import ContentConstants from '../../../contentConstants';
import { useBranchingAndLayout } from '../../../utilities/hooks';
import { CardLayout, HeaderButtonContainer, Section, WarningModal } from '../../common';
import { SurveyNoteHeaderContainer } from '../../notes/SurveyNoteHeaderContainer';
import { NoQuestionsContent } from './NoQuestionsContent';
import { PageFlowContainer } from './page-flow/PageFlowContainer';
import { BranchingAndLayoutTableContainer } from './table/BranchingAndLayoutTableContainer';
import { BranchingAndLayoutTableUtilities } from './table/BranchingAndLayoutTableUtilities';

export const BranchingAndLayout = () => {
	const {
		availableCultures,
		questions,
		hasQuestions,
		hasUnsavedChanges,
		isExpanded,
		isLoading,
		isSorting,
		isWarningModalOpen,
		pageFlowElement,
		surveyEditModel,
		handleEditPageFlowElement,
		handleExpandCollapse,
		handleJumpToStepClick,
		handlePageFlowElementModalClose,
		handleSortingChange,
		handleUpdateBeforeSortingStart,
		handleValidation,
		handleWarningModalClose,
		handleWarningModalSubmit,
	} = useBranchingAndLayout();

	return (
		<>
			<PageFlowContainer
				pageFlowElement={pageFlowElement}
				onClose={handlePageFlowElementModalClose}
				surveyEditModel={surveyEditModel}
				availableCultures={availableCultures}
			/>
			<CardLayout
				title={ContentConstants.TITLE_DESIGN_YOUR_SURVEY}
				loading={isLoading}
				header={
					<HeaderButtonContainer>
						<SurveyNoteHeaderContainer withoutContainer />
						<Button
							id='run-validation'
							color='secondary'
							size='md'
							onClick={handleValidation}
							disabled={!surveyEditModel.questions.some((q) => q.displayRulesCount > 0)}
						>
							{ContentConstants.DISPLAY_LOGIC_QUESTION_LIST_VALIDATION_BUTTON}
						</Button>
					</HeaderButtonContainer>
				}
			>
				<Section sectionHeader={ContentConstants.SECTIONHEADERS_SURVEY_LOGIC_AND_LAYOUT}>
					{!hasQuestions ? (
						<NoQuestionsContent Jump={handleJumpToStepClick} />
					) : (
						<>
							<WarningModal
								isOpen={hasUnsavedChanges && isWarningModalOpen}
								onClose={handleWarningModalClose}
								onSubmit={handleWarningModalSubmit}
								contentHeadline={ContentConstants.WARNING_MODAL_UNSAVED_HEADLINE}
								contentBody={ContentConstants.WARNING_MODAL_UNSAVED_BODY}
							/>
							<BranchingAndLayoutTableUtilities
								expanded={isExpanded}
								resultsCount={questions.length}
								onExpandCollapse={handleExpandCollapse}
							/>
							<BranchingAndLayoutTableContainer
								questions={questions}
								expanded={isExpanded}
								isSorting={isSorting}
								onSortingChange={handleSortingChange}
								updateBeforeSortStart={handleUpdateBeforeSortingStart}
								onEditPageFlowElement={handleEditPageFlowElement}
							/>
						</>
					)}
				</Section>
				{hasQuestions && (
					<>
						<Divider type='dashed' />
						<SaveButtonsGroup>
							<PreviousStepButton />
							<SaveButton />
							<SaveAndNextButton />
						</SaveButtonsGroup>
					</>
				)}
			</CardLayout>
		</>
	);
};
